var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNextPrev({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5008 28L21.0008 45.5L18.5508 43.05L33.6008 28L18.5508 12.95L21.0008 10.5L38.5008 28Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNextPrev);
export default __webpack_public_path__ + "static/media/ic-next-prev.30b9b2c11fc3a09fda499cb312fd72eb.svg";
export { ForwardRef as ReactComponent };